<template>
	<div>
		<p class="duplicate-contact-text">
			{{ text }}
		</p>
		<OverviewModalFooter
			:success="false"
			:waiting="false"
			@handleClick="handleClose"
			@close="handleClose"
			:isSaveModal="true"
			primaryButtonName="Ok"
		/>
	</div>
</template>

<script>
import OverviewModalFooter from './OverviewModalFooter.vue';
import { VIEWS } from './constants';

export default {
	name: 'DuplicateContact',
	components: { OverviewModalFooter },
	props: {
		history: Array,
	},
	computed: {
		text() {
			return this.history[1] === VIEWS.CONTACT_DETAILS
				? 'A contact with the same First name, Last name and Email already exists, Please edit the contact.'
				: 'A contact with the same First Name, Last Name, and Email Address already exists. Please go to that contact to make edits.';
		},
	},
	methods: {
		handleClose() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
.duplicate-contact-text {
	display: flex;
	align-items: center;
	@include rem('padding', 10px 20px);
}
</style>
